import { Route } from '@angular/router';

export const SiteRoutes: Route[] = [
  {
    path: 'site',
    children: [
      {
        path: 'banner',
        loadComponent: () => import('../pages/site/banner/banner.page'),
      },
      {
        path: 'business-info',
        loadComponent: () =>
          import('../pages/site/business-info/business-info.page'),
      },
      {
        path: 'bottom-banner',
        loadComponent: () =>
          import('../pages/site/bottom-banner/bottom-banner.page'),
      },
      {
        path: 'menu-text',
        loadComponent: () => import('../pages/site/menu-text/menu-text.page'),
      },
      {
        path: 'branch',
        loadComponent: () => import('../pages/site/branch/branch.page'),
      },
      {
        path: 'preorder',
        loadComponent: () => import('../pages/site/preorder/preorder.page'),
      },
      {
        path: 'promotion',
        loadComponent: () => import('../pages/site/promotion/promotion.page'),
      },
      {
        path: 'seo-management',
        loadComponent: () =>
          import('../pages/site/seo-management/seo-management.page'),
      },
      {
        path: 'partner',
        loadComponent: () => import('../pages/site/partner/partner.page'),
      },
      {
        path: 'certificate',
        loadComponent: () =>
          import('../pages/site/certificate/certificate.page'),
      },
      {
        path: 'terms',
        loadComponent: () => import('../pages/site/terms/terms.page'),
      },
      {
        path: 'popup',
        loadComponent: () => import('../pages/site/popup/popup.page'),
      },
      {
        path: 'history',
        loadComponent: () => import('../pages/history/history.page'),
      },
    ],
  },
];
